import React, { Component } from "react";
import ACTIONS from "../../common/action_constant";
import cancelIcon from "../../assets/images/model-cancel.svg";
import "./vendor_details.less";
import "./coromandel_vendors.less";

const AVATAR_COLORS = ['#528aea', '#e67e22', '#27ae60', '#8e44ad', '#c0392b', '#16a085', '#2980b9', '#d35400'];
const PAGE_LIMIT = 10;

function getInitials(name = '') {
  return name.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';
}

function getAvatarColor(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

class CoromandelVendorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      users: [],
      offset: 0,
      usersLoading: false,
    };
  }

  componentDidMount() {
    this.fetchUsers(0);
  }

  fetchUsers = (offset) => {
    const { vendor: v, seekerCompanyId, dispatch } = this.props;
    this.setState({ usersLoading: true });
    dispatch({
      type: ACTIONS.HOME.FETCH_SAP_VENDOR_USERS,
      queryParams: {
        companyId: v.id,
        limit: PAGE_LIMIT,
        offset,
        seekerCompanyId,
      },
      onSuccess: (data) => {
        this.setState({ users: data.list || [], offset, usersLoading: false });
      },
    });
  };

  goToPrev = () => {
    const { offset } = this.state;
    if (offset > 0) this.fetchUsers(offset - PAGE_LIMIT);
  };

  goToNext = () => {
    this.fetchUsers(this.state.offset + PAGE_LIMIT);
  };

  renderBadge = (value, trueLabel = 'Yes', falseLabel = 'No') => (
    <span className={`cv-badge ${value ? 'cv-badge--yes' : 'cv-badge--no'}`}>
      {value ? trueLabel : falseLabel}
    </span>
  );

  renderStatusBadge = (isActive) => (
    <span className={`cv-chip ${isActive ? 'cv-chip--active' : 'cv-chip--inactive'}`}>
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );

  renderField = (label, value) => (
    <div className="cv-field">
      <div className="cv-field-label">{label}</div>
      <div className="cv-field-value">{value || '—'}</div>
    </div>
  );

  render() {
    const { vendor: v, onClose } = this.props;
    if (!v) return null;

    const { showPassword, users, offset, usersLoading } = this.state;
    const initials = getInitials(v.company_name);
    const avatarColor = getAvatarColor(v.company_name);
    const sapCode = (v.sap_vendor_details || [])[0]?.sap_vendor_code || '—';

    return (
      <div className="vendor_detail cv-modal-root">
        <div className="overlay" onClick={onClose} />
        <div className="modal-popup cv-modal-popup" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

          <div className="cv-modal-hero" style={{ background: `linear-gradient(135deg, ${avatarColor}cc, ${avatarColor})`, flexShrink: 0 }}>
            <div className="cv-modal-avatar" style={{ background: 'rgba(255,255,255,0.2)' }}>
              {initials}
            </div>
            <div className="cv-modal-hero-info">
              <div className="cv-modal-hero-name">{v.company_name || '—'}</div>
              <div className="cv-modal-hero-sub">
                {v.pan_no && <span>PAN: {v.pan_no}</span>}
                {sapCode !== '—' && <span>SAP: {sapCode}</span>}
              </div>
              <div className="cv-modal-hero-badges">
                {this.renderStatusBadge(v.is_active)}
                {v.is_vendor_master && <span className="cv-badge cv-badge--master">Vendor Master</span>}
              </div>
            </div>
            <img src={cancelIcon} className="cv-modal-close-btn" onClick={onClose} alt="close" />
          </div>

          <div className="cv-modal-body">

            <div className="cv-section-label">Contact Information</div>
            <div className="cv-field-grid">
              {this.renderField('Email', v.email)}
              {this.renderField('User Email', v.user_email)}
              {this.renderField('Contact', v.contact || v.user_contact)}
              {this.renderField('Admin Name', v.admin_name)}
              {this.renderField('GSTIN', v.gstin)}
              {this.renderField('Bank Account No', v.bank_account_no)}
              {/* <div className="cv-field">
                <div className="cv-field-label">Password</div>
                <div className="cv-field-value cv-password-row">
                  <span className="cv-password-text">
                    {showPassword ? (v.password || '—') : (v.password ? '••••••••' : '—')}
                  </span>
                  {v.password && (
                    <span
                      className="cv-password-toggle"
                      onClick={() => this.setState(s => ({ showPassword: !s.showPassword }))}
                    >
                      {showPassword ? '🙈 Hide' : '👁 View'}
                    </span>
                  )}
                </div>
              </div> */}
            </div>

            <div className="cv-section-label">SAP Vendor Details</div>
            {(v.sap_vendor_details || []).length > 0 ? (
              <div className="cv-inner-table">
                <div className="cv-inner-row cv-inner-header">
                  <span>SAP Vendor Code</span>
                  <span>Company</span>
                  <span>Branches</span>
                </div>
                {(v.sap_vendor_details || []).map((sap, i) => {
                  const branches = (sap.branch_id || []).map(b => b.label).filter(Boolean);
                  return (
                    <div className="cv-inner-row" key={i}>
                      <span className="cv-sap-code">{sap.sap_vendor_code || '—'}</span>
                      <span>{sap.company || '—'}</span>
                      <span>{branches.length > 0 ? branches.join(', ') : '—'}</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="cv-empty-sub">No SAP vendor details available</div>
            )}

            {(v.gstin_details || []).length > 0 && (
              <>
                <div className="cv-section-label">GSTIN Details</div>
                <div className="cv-inner-table">
                  <div className="cv-inner-row cv-inner-header">
                    <span>State</span>
                    <span>GSTIN</span>
                  </div>
                  {(v.gstin_details || []).map((g, i) => (
                    <div className="cv-inner-row" key={i}>
                      <span>{g.state || '—'}</span>
                      <span>{g.gstin || '—'}</span>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className="cv-section-label">Capabilities</div>
            <div className="cv-capabilities">
              <div className="cv-cap-item">
                <span className="cv-cap-label">Multimode</span>
                {this.renderBadge(v.is_multimode, 'Yes', 'No')}
              </div>
              <div className="cv-cap-item">
                <span className="cv-cap-label">Warehouse</span>
                {this.renderBadge(v.is_warehouse, 'Yes', 'No')}
              </div>
              <div className="cv-cap-item">
                <span className="cv-cap-label">Service Types</span>
                <span className="cv-cap-value">
                  {(v.service_type || []).filter(s => s.name).map(s => s.name).join(', ') || '—'}
                </span>
              </div>
              <div className="cv-cap-item">
                <span className="cv-cap-label">Category Types</span>
                <span className="cv-cap-value">
                  {(v.category_type || []).filter(c => c.name).map(c => c.name).join(', ') || '—'}
                </span>
              </div>
              <div className="cv-cap-item">
                <span className="cv-cap-label">Additional Services</span>
                <span className="cv-cap-value">
                  {(v.additional_service_type || []).filter(a => a.name).map(a => a.name).join(', ') || '—'}
                </span>
              </div>
            </div>

            <div className="cv-section-label cv-users-label">
              <span>Users</span>
              <div className="cv-page-nav">
                <button className="cv-page-nav-btn" onClick={this.goToPrev} disabled={offset === 0}>&#8249;</button>
                <button className="cv-page-nav-btn" onClick={this.goToNext}>&#8250;</button>
              </div>
            </div>

            {usersLoading ? (
              <div className="cv-users-loading">
                <span className="cv-search-spinner" style={{ display: 'inline-block' }} />
                <span>Loading users...</span>
              </div>
            ) : users.length === 0 ? (
              <div className="cv-empty-sub">No users found</div>
            ) : (
              <div className="cv-inner-table cv-users-table">
                <div className="cv-inner-row cv-inner-header">
                  <span>#</span>
                  <span>Name</span>
                  <span>Email</span>
                  <span>Contact</span>
                  <span>Branches</span>
                  <span>Status</span>
                </div>
                {users.map((u, i) => {
                  const branches = ((u.company_list || [])[0]?.branches || []).map(b => b.branch_name).filter(Boolean);
                  return (
                    <div className="cv-inner-row" key={u.user_id || i}>
                      <span className="cv-users-sl">{offset + i + 1}</span>
                      <span>{u.user_name || '—'}</span>
                      <span>{u.user_email || u.email || '—'}</span>
                      <span>{u.user_contact || '—'}</span>
                      <span>{branches.length > 0 ? branches.join(', ') : '—'}</span>
                      <span>{this.renderStatusBadge(u.is_active)}</span>
                    </div>
                  );
                })}
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default CoromandelVendorModal;
